<template>
  <div class="agent-auth-error">
    <div class="agent-auth-error-card">
      <div class="agent-auth-error-title">{{ $t('widget.agent.authError.title') }}</div>
    </div>
  </div>
</template>

<script lang="ts">
/**
 * Purpose: 客服身份 token 校验失败时的极简全屏错误页。刻意不做重试按钮 —— token 由后端签发
 * 时嵌入 URL，前端无法自愈；提示"从来源重新打开链接"即可。
 */
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AgentAuthError',
})
</script>

<style lang="less" scoped>
.agent-auth-error {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9faf9;
  z-index: 999;
}

.agent-auth-error-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 32px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06);
  max-width: 320px;
  text-align: center;
}

.agent-auth-error-title {
  font-size: 16px;
  font-weight: 500;
  color: #202221;
}

.agent-auth-error-desc {
  font-size: 14px;
  color: #63676a;
  line-height: 20px;
}
</style>
